export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '派单时间',
		align: 'center',
		dataIndex: 'orderCreateTime',
		scopedSlots: { customRender: 'orderCreateTime' },
	},
	{
		title: '派单机构',
		align: 'center',
		dataIndex: 'companyName',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
	},
	{
		title: '初次探视订单号',
		align: 'center',
		dataIndex: 'orderNo',
	},
	{
		title: '伤者姓名',
		align: 'center',
		dataIndex: 'injuryName',
	},
	{
		title: '伤者电话',
		align: 'center',
		dataIndex: 'phones',
	},
	{
		title: '实际就诊医院',
		align: 'center',
		dataIndex: 'hospital',
	},
	{
		title: '最近回访时间',
		align: 'center',
		dataIndex: 'revisitTime',
		scopedSlots: { customRender: 'revisitTime' },
	},
	{
		title: '最近回访状态',
		align: 'center',
		dataIndex: 'revisitStatus',
		scopedSlots: { customRender: 'revisitStatus' },
	},
	{
		title: '回访人',
		align: 'center',
		dataIndex: 'revisitorName',
	},
	{
		title: '操作',
		align: 'center',
		scopedSlots: { customRender: 'action' },
	},
]
